'use strict';
angular.module('manageProAppSiteModule', [
    'mangeProAppSiteServiceModule',
    'productManageMentAppSiteRouterModule',
    'productManageMentAppSiteRecycleBinModule',
])
    .controller('manageAppSiteController', ['$scope', '$rootScope', '$modal', '$timeout', '$location', '$state', '$stateParams', '$q', 'trsHttpService', 'localStorageService', 'modalDialog', 'productMangageMentAppService', 'permissionService', 'websiteService', 'previewToolService', 'sortOfSitesService', 'trsspliceString',
        function ($scope, $rootScope, $modal, $timeout, $location, $state, $stateParams, $q, trsHttpService, localStorageService, modalDialog, productMangageMentAppService, permissionService, websiteService, previewToolService, sortOfSitesService, trsspliceString) {
            initStatus();
            initData();

            /**
             * [getSiteRights description]获取每个站点的操作权限
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.getSiteRights = function (item) {
                productMangageMentAppService.getRight(item.SITEID, '', 'appsetsite.site').then(function (data) {
                    $scope.status.rights[item.SITEID] = data;
                });
            };
            // 获取站点操作权限结束
            $scope.addViews = function () {
                $scope.loadingPromise = saveSite('新建站点', '', $scope.status.data.sites);
            };

            /**
             * [clickSiteDirected description]点击站点重定向开始
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.clickSiteDirected = function (item) {
                if (!$scope.status.rights[item.SITEID].site.bianji) {
                    return;
                } else {
                    $scope.modifyViews(item);
                }

                // $stateParams.site = item.SITEID;
                // $stateParams.site = item.SITEID;
                // $state.transitionTo($state.current, $stateParams, {
                //     reload: false
                // });
                // productMangageMentAppService.getChannelAccessAuthority(item.SITEID).then(
                //     function(data) {
                //         //將权限信息存入缓存，用于底部路由区加载使用开始
                //         localStorageService.remove("appRightOperType_site"); //初始化缓存
                //         localStorageService.set("appRightOperType_site", {
                //             type: data.router,
                //             data: data.data
                //         });
                //         $stateParams.status = item.STATUS;
                //         //將权限信息存入缓存，用于底部路由区加载使用结束
                //         $state.go("manageconfig.productmanage.app." + data.router, $stateParams, { reload: true });
                //     }
                // );
                // productMangageMentWebsiteService.getOperType(item.SITEID, "").then(function(data) {
                //     var router = "";
                //     for (var key in data) {
                //         switch (key) {
                //             case "channel":
                //                 router += "channel";
                //                 break;
                //             case "template":
                //                 router += "template";
                //                 break;
                //             case "widget":
                //                 router += "fragment";
                //                 break;
                //             case "publishdistribution":
                //                 router += "distributeconfig";
                //                 break;
                //         }
                //         break;
                //     }
                //     if (router === "") {
                //         modalDialog.alertType("您无权查看该站点下的频道", "您无权查看该站点下的频道", "error", confirm);
                //     } else {
                //         //將权限信息存入缓存，用于底部路由区加载使用开始
                //         localStorageService.remove("appRightOperType_site"); //初始化缓存
                //         localStorageService.set("appRightOperType_site", { type: router, data: data });
                //         //將权限信息存入缓存，用于底部路由区加载使用结束
                //         $state.go("manageconfig.productmanage.website." + router);
                //     }
                // });
            };
                
            /**
                 * [modifyViews description]
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
            $scope.modifyViews = function (item) {
                var modParams = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'findAppSiteById',
                    SiteId: item.SITEID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), modParams, 'post')
                    .then(function (data) {
                        var siteInfo = {
                            ISORIGINAL: item.ISORIGINAL,
                            ObjectId: item.SITEID,
                            repeatUseTime: data.REPEATUSETIME,
                            SiteName: data.SITEDESC,
                            SiteDesc: data.SITEDESC,
                            DataPath: data.DATAPATH,
                            SiteOrder: data.SITEORDER,
                            RootDoMain: data.ROOTDOMAIN,
                            CheckFgdAttribute: parseInt(data.CHECKFGDATTRIBUTE),
                            ExternalSys: parseInt(data.EXTERNALSYS),
                            isTrashPubDoc: parseInt(data.ISTRASHPUBDOC),
                            PICTEXTTYPESET: parseInt(data.PICTEXTTYPESET),
                            TYPEFACEDEFINITION: data.TYPEFACEDEFINITION,
                            temp: {},
                            otherTemp: {},
                            xilanTemp: {},
                            ISPAICHONG: parseInt(data.ISPAICHONG),
                            ISPGC: data.ISPGC,
                            picsize: data.PICSIZE,
                            IsSecondReview: parseInt(data.ISSECONDREVIEW),
                            RelatedTopic: parseInt(data.RELATEDTOPIC),
                            ConnectionColumn: parseInt(data.CONNECTIONCOLUMN),
                            RelatedOfficial: parseInt(data.RELATEDOFFICIAL),
                            CKMSIMDAYRANGE: parseInt(isNaN(data.CKMSIMDAYRANGE) ? '0' : data.CKMSIMDAYRANGE), // 稿件排重时间范围
                            APPMODULEID: data.APPMODULEID, // 编辑器自定义功能
                            EDITORTYPEFACE: data.EDITORTYPEFACE, // 编辑器字体设置
                            ROWSPACINGSETTING: data.ROWSPACINGSETTING, // 编辑器行距设置
                            EDITORWORDS: data.EDITORWORDS, // 编辑器字号设置
                            HEADLINEDOCREVIEW: data.HEADLINEDOCREVIEW, // 推头条稿件审核配置 默认0 不需要审核， 1需要审核
                        };
                        // 编辑时默认绑定模板数据转换开始
                        siteInfo.temp.TEMPID = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPID : '0';
                        siteInfo.otherTemp.TEMPID = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPID : '0';
                        siteInfo.xilanTemp.TEMPID = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPID : '0';
                        siteInfo.temp.TEMPNAME = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPNAME : '';
                        siteInfo.otherTemp.TEMPNAME = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPNAME : '';
                        siteInfo.xilanTemp.TEMPNAME = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPNAME : '';
                        siteInfo.siteId = $stateParams.site;
                        // 编辑时默认绑定模板数据转换结束
                        $scope.loadingPromise = saveSite('修改站点', siteInfo, $scope.status.data.sites);
                    });
            };
            // 发布站点
            // $scope.publish = function (item) {
            //     websiteService.websitePublish(item.SITEID, '103');
            // };

            /**
             * [publish description]批量发布站点
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.publish = function (item) { // 22
                $scope.status.selectedPublishWay = item.value;
                if ($scope.status.selectedArray.length !== 1) {
                    modalDialog.alertType('请选择一个站点', '', 'warning', false);
                    return;
                }
                $timeout(function () {
                    if ($scope.status.selectedPublishWay === 0) {$scope.publishHome($scope.status.selectedArray[0]);} else {$scope.publishFull($scope.status.selectedArray[0]);}
                });
            };
            // 预览站点
            $scope.preview = function (item) {
                previewToolService.sitePreview(item);
            };

            /**
             * [enableDisable description]启用停用站点
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.enableDisable = function (item) {
                if (item.STATUS === '0') {
                    $scope.disableSite(item);
                } else {
                    $scope.reductionViews(item);
                }
            };


            /**
             * [disableSite description]停用站点
             * @return null [description]
             */

            $scope.disableSite = function (item) {
                var checkParams = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'deleteWebsiteCondition',
                    SiteId: item.SITEID,
                };
                var deleteParams = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'deleteSite',
                    SiteId: item.SITEID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, 'post')
                    .then(function (data) {
                        modalDialog.inputModel('停用', '停用原因（选填）', function (data) {
                            productMangageMentAppService.inputPassword(function (password) {
                                LazyLoad.js(['./lib/js-base64/base64.js',], function () {
                                    deleteParams.PassWord = '__encoded__' + Base64.encode(angular.copy(password));
                                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, 'post')
                                        .then(function (data) {
                                            modalDialog.alertType('停用站点成功', '', 'success', false);
                                            requestData();

                                            /* $state.go($state.current.name, $stateParams, {
                                                reload: true
                                            });*/
                                        });
                                });
                            });
                        });
                    });
            };

            /**
             * [reductionViews description]启用站点
             *
             * @param   {[type]}  item  [item description]站点信息
             *
             * @return  {[type]}        [return description]
             */
            $scope.reductionViews = function (item) {
                modalDialog.alertType('确定启用该站点？', '', 'ask', true, function (data) {
                    var reSiteParams = {
                        serviceid: 'mlf_appconfig',
                        methodname: 'restoreSites',
                        ObjectIds: item.SITEID,
                        RestoreAll: false,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, 'post')
                        .then(function (data) {
                            modalDialog.alertType('启用成功', '', 'success', false);
                            requestData();
                        });
                });
            };

            /**
             * [sortOfSites description] 站点排序
             * @return {[type]} [description]
             */
            $scope.sortOfSites = function () {
                if ($scope.status.selectedArray.length !== 1) {
                    modalDialog.alertType('请选择一个站点', '', 'warning', false);
                    return;
                }
                var index = $scope.status.data.sites.indexOf($scope.status.selectedArray[0]) + 1;
                sortOfSitesService.sorts('app', index, $scope.status.selectedArray[0], $scope.status.data.sites, function (data) {
                    if (data.ISSUCCESS == 'true') {
                        $state.go($state.current.name, $stateParams, { reload: true, });
                    }
                });

            };

            /**
             * [batDelete description] 批量删除站点
             * @return {[type]} [description]
             */
            $scope.batDelete = function () {
                if ($scope.status.selectedArray.length == 0) {
                    modalDialog.alertType('请先选择一个站点', '', 'warning', false);
                    return;
                } else {
                    modalDialog.alertType('确定要删除选中的站点吗', '', 'warning', true, function () {
                        $scope.deleteViews($scope.status.selectedArray);
                    });
                }
            };

            /**
             * [deleteViews description]删除站点
             *
             * @param   {[type]}  item  [item description]站点信息
             *
             * @return  {[type]}        [return description]
             */
            $scope.deleteViews = function (item) {
                $scope.selectChannelIds = trsspliceString.spliceString(item, 'SITEID', ',');
                var ckConditionParamas = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'checkWebsiteCondition',
                    SiteIds: $scope.selectChannelIds,
                };
                var deleteParams = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'removeSites',
                    SiteIds: $scope.selectChannelIds,
                    PassWord: '',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, 'get')
                    .then(function (data) {
                        productMangageMentAppService.inputPassword(function (password) {
                            LazyLoad.js(['./lib/js-base64/base64.js',], function () {
                                deleteParams.PassWord = '__encoded__' + Base64.encode(angular.copy(password));
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, 'get')
                                    .then(function (data) {
                                        modalDialog.alertType('删除成功', '', 'success', false);
                                        requestData();
                                    });
                            });
                        });
                    });
            };


            $scope.search = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.params.SiteDesc = $scope.searchWord;

                    /* $state.transitionTo($state.current, $stateParams, {
                        reload: false
                    });*/
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'post').then(
                        function (data) {
                            localStorageService.set('manageconfig.app.sites', data);
                            $scope.status.data.sites = data.DATA;

                            /* $state.transitionTo($state.current, $stateParams, {
                                reload: true
                            });*/
                        });
                }
            };

            /**
             * [initStatus description]数据
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    ITEMCOUNT: 0,
                    PAGESIZE: 20,
                    CURRPAGE: 1,
                    PAGECOUNT: 0,
                    copyCurrPage: 1,
                };
                $scope.status = {
                    routerPath: $location.path().split('/'),
                    data: {
                        sites: '',
                        selectedSite: '',
                    },
                    params: {
                        'serviceid': 'mlf_appconfig',
                        'methodname': 'queryAppSitesForCloud',
                        'SiteDesc': $stateParams.sitedesc,
                    },
                    statusOptions: [{
                        name: '全部状态',
                    }, {
                        name: '启用',
                        value: 0,
                    }, {
                        name: '停用',
                        value: -1,
                    }, ],
                    selectedArray: [],
                    rights: {},
                    publishOptions: [{ name: '仅发布首页', value: 0, }, { name: '全站发布', value: 1, }, ],
                };
                $scope.status.selectStatus = $scope.status.statusOptions[0];
                
                permissionService.isTenantAdministrator().then(function (data) {
                    $scope.status.isTenantAdministrator = data; // 是否是系统管理员
                });
            }
            //
            $scope.$on('leftSaveAppToChildren', function (event, value) {
                initData();
            });

            /**
             * [selectStatus description]根据状态筛选站点
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectStatus = function () {
                $scope.status.params.status = $scope.status.selectStatus.value;
                requestData();
            };

            /**
             * [initData description]初始化
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                requestData().then(function (data) {
                    $scope.status.data.sites = data.DATA;
                    $scope.status.data.selectedSite = getSiteById($scope.status.data.sites, $location.search().site);
                    $scope.searchWord = $stateParams.sitedesc;
                });
            }

            /**
             * [selectAll description]全选
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectAll = function () {
                $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.status.data.sites.length ? [] : [].concat($scope.status.data.sites);
            };

            /**
             * [selectDoc description]单选
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectDoc = function (item) {
                if ($scope.status.selectedArray.indexOf(item) < 0) {
                    $scope.status.selectedArray.push(item);
                } else {
                    $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(item), 1);
                }
            };

            /**
             * [getSiteById description] 得到站点
             *
             * @param   {[type]}  sites   [sites description]
             * @param   {[type]}  siteid  [siteid description]
             *
             * @return  {[type]}          [return description]
             */
            function getSiteById(sites, siteid) {
                if (angular.isDefined(sites)) {
                    for (var i = 0; i < sites.length; i++) {
                        if (sites[i].SITEID == siteid) {return sites[i];}
                    }
                }
            }

            /**
             * [jumpToPage description]跳转到第几页
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function () {
                $scope.status.params.PageIndex = $scope.page.CURRPAGE = $scope.params.copyCurrPage;
                requestData();
            };

            /**
             * [pageChanged description]翻页功能
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function () {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                $scope.status.params.PageIndex = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [selectPageNum description]选择单页数据条数
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectPageNum = function () {
                $scope.status.params.PageSize = $scope.page.PAGESIZE;
                requestData();
            };

            /**
             * [requestData description]数据
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var deferred = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function (data) {
                    $scope.status.data.sites = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                    $state.transitionTo($state.current, $stateParams, {
                        reload: false,
                    });
                    deferred.resolve(data);
                });
                return deferred.promise;
            }

            /**
             * [saveSite description]保存站点
             *
             * @param   {[type]}  title     [title description]
             * @param   {[type]}  siteInfo  [siteInfo description]
             * @param   {[type]}  allSite   [allSite description]
             *
             * @return  {[type]}            [return description]
             */
            function saveSite(title, siteInfo, allSite) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/app/site/template/app_modify_tpl.html',
                    windowClass: 'productManageMent-app-modify-view',
                    backdrop: false,
                    controller: 'mangeProAppSiteModCtrl',
                    resolve: {
                        params: function () {
                            return {
                                title: title,
                                siteInfo: siteInfo,
                                allSite: allSite,
                            };
                        },
                    },
                });
                modalInstance.result.then(function (newsite) {
                    newsite.serviceid = 'mlf_appconfig';
                    newsite.methodname = 'saveNewSite';
                    newsite.SiteDesc = newsite.SiteDesc;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), newsite, 'post').then(function (data) {
                        modalDialog.alertType('保存成功', '', 'success', false);
                        $state.go($state.current.name, $stateParams, {
                            reload: true,
                        });
                        deffer.resolve();
                    }, function () {
                        deffer.resolve();
                    });
                }, function () {
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [singlePublish description] 单个站点发布
             * @param {[object]} [site] [description] 站点信息
             * @return {[type]} [description]
             */
            $scope.singlePublish = function (site) {
                $timeout(function () {
                    if ($scope.status.selectedPublishWay.value === 0) {$scope.publishHome(site);} else {$scope.publishFull(site);}
                });
            };

            // 仅发布到首页
            $scope.publishHome = function (item) {
                if (!$scope.status.rights[item.SITEID].site.solopublish) {
                    modalDialog.alertType('您没有这个站点的仅发布首页权限', '', 'warning', 'confirm');
                    return;
                }
                modalDialog.alertType('确认发布该站点首页吗？', '', 'ask', true, function (data) {
                    websiteService.websitePublish(item.SITEID, '103');
                });
            };
            // 全部发布
            $scope.publishFull = function (item) {
                if (!$scope.status.rights[item.SITEID].site.publish) {
                    modalDialog.alertType('您没有这个站点的全站发布权限', '', 'warning', 'confirm');
                    return;
                }
                modalDialog.alertType('确认要全站发布吗？', '', 'ask', true, function (data) {
                    var publishParams = {
                        serviceid: 'mlf_publish',
                        methodname: 'fullyPublish',
                        ObjectIds: item.SITEID,
                        ObjectType: '103',
                    };
                    // 2020-01-15将post请求更改为get请求
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), publishParams, 'get').then(
                        function (data) {
                            modalDialog.alertType('发布成功', '', 'success', false);
                        });
                });
            };
        },
    ]);
